import { v as v4 } from '../../v4-c5e36445.js';

var getBaseLayerDefaultAttrs = function getBaseLayerDefaultAttrs() {
  return {
    id: v4(),
    x: 0,
    y: 0,
    dragBounds: {
      minX: Number.MIN_SAFE_INTEGER,
      minY: Number.MIN_SAFE_INTEGER,
      maxX: Number.MAX_SAFE_INTEGER,
      maxY: Number.MAX_SAFE_INTEGER
    },
    width: 0,
    height: 0,
    rotation: 0,
    scaleX: 1,
    scaleY: 1,
    dependencies: [],
    draggable: true,
    transformable: true,
    visible: true,
    selectable: true,
    listening: true,
    interactable: true,
    meta: {},
    globalCompositeOperation: 'source-over',
    opacity: 1
  };
};

export { getBaseLayerDefaultAttrs as default };
